/* eslint-disable */
import axios from 'axios';

export default {
    state : {
        postTypes : [],
    },

    methods : {

    },

    getters : {

        getAllPostTypes(state) {

            return state.postTypes;

        },

        getPerimeterPostTypes(state) {
            return state.postTypes.filter(item => item.region ==0);
        },

        getPostTypeById: state => id => {
            return state.postTypes.find(item => item.id == id);
        },

        isPerimeterPostType : state =>id => {
            let post =  state.postTypes.find(item => item.id == id);
            return post.region == 0;
        },

    },

    mutations: {

        setPostTypes(state, postTypes) {
            state.postTypes = postTypes;
        }
    
    },

    actions : {

        getPostTypes({dispatch, commit, rootState}) {

            return new Promise((resolve, reject) => {
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                    axios.get('/postTypes')
                    .then(response => {
                        commit('setPostTypes', response.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        if ((error.response.status == 401)||(error.response.status == 500)) {
                            console.log(error);
                        }
                        else {
                            let t = error.response.status == 429 ? 15000 : 1500;
                            if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];
                            setTimeout(()=>{        // повторная загрузка через секунду
                                dispatch('getPostTypes');
                            }, t);
                            reject(error.response.status)
                        }
                    });
            });
        },

    }

}